import React, { useEffect, useState } from "react";
import AdminLayout from "../../Layout/index.jsx";
import NetworkIndicator from "../../../Practice/Components/NetworkIndicator.jsx";
import { useParams, useNavigate } from "react-router-dom";
import { CommandLineIcon } from "@heroicons/react/24/solid";
import { IoMdArrowRoundBack } from "react-icons/io";
import { FaEllipsisV } from "react-icons/fa";
import EditAssignmentModal from "../../Components/EditAssignmentModal.jsx";
import ConformationModal from "../../Components/ConformationModal.jsx";
import {
  useDeleteAssignmentMutation,
  useDeleteAssignmentQuestionMutation,
  
  useGetAdminUsingEmailQuery,
  
  useGetAllAssignmentQuestionQuery,
  useGetAssignmentQuery,
  useRemoveAssignmentMutation,
} from "../../../../graphql/generated.tsx";
import formatDate from "../../Helpers/formatDate.jsx";
import AssignmentQuestionListing from "./Questions/AssignmentQuestionListing.jsx";
import { Dropdown } from "flowbite-react";
import { GiAlarmClock } from "react-icons/gi";
import { CiClock2, CiViewList } from "react-icons/ci";
import Loader from "../../../../components/Loader.jsx";

const AssignmentDetails = () => {
  const { id, folderid } = useParams();
  const navigate = useNavigate();
  const [assignment, setAssignments] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false); // New state for delete confirmation modal
  const [assignmentQuestion, setAssignmentQuestion] = useState();
  const [Isload, setIsload] = useState(true)

  
  const { data, loading } = useGetAssignmentQuery({ variables: { id } });
  const { data: AssignmentQuestions, refetch } =
    useGetAllAssignmentQuestionQuery({
      variables: { assignmentId: id },
    });
  const [deleteAssignment] = useRemoveAssignmentMutation();
  const [deleteAssignmentQuestion] = useDeleteAssignmentQuestionMutation();

  useEffect(() => {
    refetch();
    if (data?.getAssignment) setAssignments(data?.getAssignment);
  }, [data]);

     useEffect(()=>{
    setTimeout(()=>{
      setIsload(false);
    },2000);
  },[]);

  useEffect(() => {
    refetch();
    if (AssignmentQuestions?.getAllAssignmentQuestion) {
      setAssignmentQuestion(AssignmentQuestions.getAllAssignmentQuestion);
    }
  }, [AssignmentQuestions]);

  const handleEditClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleDeleteAssignment = async () => {
    try {
      await deleteAssignment({ variables: { folderId: folderid, id: id } });
      navigate(-1);
    } catch (error) {
      console.error("Error deleting assignment:", error);
    }
  };

  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

  const handleDeleteQuestion = async (questionId) => {
    try {
      await deleteAssignmentQuestion({ variables: { id: questionId } });
      refetch();
      setAssignmentQuestion(
        assignmentQuestion.filter((question) => question.id !== questionId)
      );
    } catch (error) {
      console.error("Error deleting question:", error);
    }
  };

  const email = JSON.parse(localStorage.getItem("user"))?.email;
  const { data: admin } = useGetAdminUsingEmailQuery({
    variables: { email },
    skip: !email,
  });

  const formatDuration = (durationInHours) => {
    const totalMinutes = Math.round((Number(durationInHours) || 0) * 60);
    if (totalMinutes <= 0) return "0m";

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours > 0 && minutes > 0) return `${hours}h ${minutes}m`;
    if (hours > 0) return `${hours}h`;
    return `${minutes}m`;
  };

  if (loading || Isload ) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center h-screen">
        <Loader />
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <NetworkIndicator />
      <div className="p-8 max-md:p-5">
        <button
          onClick={() => window.history.back()}
          className="text-gray-500 hover:text-gray-700 focus:outline-none"
        >
          <span className="flex items-center gap-2 text-sm font-medium">
            <IoMdArrowRoundBack className="w-6 h-6" />
            Go Back
          </span>
        </button>
        <div className="relative px-6 py-8 mt-5 bg-white rounded-md shadow-sm">
          <div className="absolute top-7 right-5">
            <Dropdown
              arrowIcon={false}
              inline={true}
              className="w-44"
              label={
                <FaEllipsisV className="w-6 h-6 text-gray-500 cursor-pointer hover:text-primary" />
              }
            >
              {admin?.getAdminUsingEmail?.isSuperAdmin && (
                <>
                  <Dropdown.Item onClick={handleEditClick}>
                    Edit Assignment
                  </Dropdown.Item>
                  <hr className="w-full" />
                </>
              )}
              <Dropdown.Item
                onClick={() =>
                  navigate(
                    `/admin/assignment-folders/${folderid}/assignments/${id}/add-question`
                  )
                }
              >
                Add New Question
              </Dropdown.Item>
              <hr className="w-full" />
              <Dropdown.Item
                onClick={() =>
                  navigate(
                    `/admin/assignment-folders/${folderid}/assignments/${id}/import-question`
                  )
                }
              >
                Import Question
              </Dropdown.Item>
              <hr className="w-full" />
              <Dropdown.Item onClick={handleDeleteClick}>
                Delete Assignment
              </Dropdown.Item>
            </Dropdown>
          </div>

          {showModal && (
            <EditAssignmentModal
              id={id}
              onClose={handleCloseModal}
              setAssignments={setAssignments}
              assignment={assignment}
            />
          )}

          {showDeleteModal && (
            <ConformationModal
              openModal={showDeleteModal}
              setOpenModal={setShowDeleteModal}
              event={handleDeleteAssignment}
              text="Are you sure you want to delete this assignment?"
            />
          )}

          {/* Assignment Details and Questions List */}
          <div className="flex flex-col gap-4 md:flex-row md:items-center">
            <div className="inline-block p-6 bg-orange-100 rounded-lg max-md:w-1/2">
              <CommandLineIcon className="w-12 h-12 text-orange-500" />
            </div>
            <div className="md:max-w-screen-sm">
              <div className="mb-2 text-xl font-bold">{assignment?.name}</div>
              <div className="text-sm text-slate-500">
                {assignment?.description}
              </div>
            </div>
          </div>
          <hr className="my-6 w-screen-md" />
          <div className="flex flex-wrap gap-32">
            <div className="flex flex-col items-center justify-center">
              <CiClock2 className="w-5 h-5 text-slate-500" />
              <span className="mb-1 text-sm text-slate-500">Due Date</span>
              <span className="font-bold">
                {formatDate(assignment?.due_date) || "Not Set"}
              </span>
            </div>
            <div className="flex flex-col items-center justify-center">
              <CiViewList className="w-5 h-5 text-slate-500" />
              <span className="mb-1 text-sm text-slate-500">
                Number of Questions
              </span>
              <span className="font-bold">
                {assignmentQuestion ? assignmentQuestion.length : 0}
              </span>
            </div>
            <div className="flex flex-col items-center justify-center">
              <GiAlarmClock className="w-5 h-5 text-slate-500" />
              <span className="mb-1 text-sm text-slate-500">Duration</span>
              <span className="font-bold">
                {assignment ? formatDuration(assignment?.duration) : "0m"}
              </span>
            </div>
          </div>
        </div>

        <h1 className="my-5 text-2xl font-bold text-center">Questions</h1>
        <div className="p-8 mt-8 bg-white rounded-md max-md:p-5 min-h-2xl">
          {assignmentQuestion?.map((assignment, index) => (
            <div key={index}>
              <AssignmentQuestionListing
                onDelete={handleDeleteQuestion}
                data={assignment}
                assignmentId={id}
                folderid={folderid}
              />
              {index !== assignmentQuestion.length - 1 && (
                <hr className="px-8 my-4" />
              )}
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
};

export default AssignmentDetails;
